export const manifest = {
  screens: {
    scr_d2oh3h: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_5zikte: { name: "Product", route: "/product/1", position: {"x":1560,"y":220} },
  },
  sections: {
    sec_tmfr2m: { name: "Product browsing", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_tmfr2m", children: [
      { kind: "screen", id: "scr_d2oh3h" },
      { kind: "screen", id: "scr_5zikte" },
    ] },
  ],
}
